module.exports = __webpack_public_path__ + "static/media/tlyfepro.4c2666ca.png";